// ═══ 인보이스 목록 드롭다운 — Invoice.js에서 분리 ═══
// 저장된 인보이스 목록을 드롭다운으로 표시하고 선택 시 loadInvoice 호출
import React from 'react';

function InvoiceList(props) {
  var c = props.c;
  var handleNew = function(){
    if(c.setSavedInvoiceId)c.setSavedInvoiceId(null);
    if(c.setShoringFiles)c.setShoringFiles([]);
    if(c.resetForm)c.resetForm();
  };
  return (
    <div style={{marginBottom:10,background:'#f8fafc',border:'1px solid #e2e8f0',borderRadius:10,padding:'10px 14px'}}>
      <div style={{display:'flex',alignItems:'center',gap:8,marginBottom:4}}>
        <label style={{fontSize:12,fontWeight:600,color:'#64748b',flex:1}}>저장된 인보이스</label>
        <button onClick={handleNew} style={{padding:'4px 12px',borderRadius:6,border:'1px solid #2563eb',background:'#eff6ff',color:'#2563eb',fontSize:11,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>+ 새 인보이스</button>
      </div>
      {(!c.savedList||c.savedList.length===0)?<div style={{fontSize:12,color:'#94a3b8',textAlign:'center',padding:'6px 0'}}>저장된 인보이스 없음</div>:(function(){
        var selected=(c.savedList||[]).find(function(inv){return inv.id===c.savedInvoiceId});
        // 발송완료/발송대기/임시저장 모든 상태 삭제 가능 — 선택된 인보이스가 있으면 버튼 노출
        // sent 인보이스는 관세사 전송 이력이 있어 강조 스타일 + 경고 (deleteDraft에서 확인)
        var canDelete=!!selected;
        var isSent=selected&&selected.invoice_status==='sent';
        return(
          <div style={{display:'flex',gap:6,alignItems:'stretch',flexWrap:'wrap'}}>
            <select style={{flex:'1 1 220px',minWidth:0,padding:'8px 10px',border:'1px solid #d0d5dd',borderRadius:6,fontSize:13,cursor:'pointer'}} value={c.savedInvoiceId||''} onChange={function(e){var id=parseInt(e.target.value);if(id)c.loadInvoice(id)}}>
              <option value="">저장된 인보이스 선택...</option>
              {c.savedList.map(function(inv){
                var statusLabel=inv.invoice_status==='sent'?'발송완료':inv.invoice_status==='ready'?'발송대기':'임시저장';
                var buyerLabel=inv.buyerName||inv.consigneeName||'-';
                var containerLabel=inv.containerNo?' | '+inv.containerNo:'';
                var dateLabel=(inv.createdAt||'').slice(5,10);
                var vinTail=inv.cars&&inv.cars.length>0?' ['+inv.cars.map(function(cc){return (cc.vin||'').slice(-6)}).filter(function(v){return v}).join(',')+']':'';
                return(<option key={inv.id} value={inv.id}>#{inv.id} {buyerLabel}{containerLabel}{vinTail} ({dateLabel}) [{statusLabel}]</option>);
              })}
            </select>
            {canDelete&&<button onClick={function(){if(c.deleteDraft)c.deleteDraft(c.savedInvoiceId)}} title={isSent?'발송완료 인보이스 삭제 (차량 상태 자동 복구 안 됨)':'인보이스 삭제'} style={{flex:'0 0 auto',padding:'0 14px',borderRadius:6,border:isSent?'1px solid #ef4444':'1px solid #fca5a5',background:isSent?'#fef2f2':'#fff',color:'#dc2626',fontSize:12,fontWeight:700,cursor:'pointer',whiteSpace:'nowrap'}}>🗑️ 삭제</button>}
          </div>
        );
      })()}
    </div>
  );
}

export default InvoiceList;
